module.exports = "/_next/static/images/e2225f4cbc5cf83951bc27e9737b2fac-card-background-right-xs.jpg";